import MessageFileViewer from "./messageFileViewer";
import styles from "../communication-chat.module.css";
import { useEffect, useRef, useState } from "react";
import ContentLoader from "react-content-loader";
import { useHistory } from "react-router-dom";
import moment from "moment";
import CopyToClipboard from "react-copy-to-clipboard";
import { Tooltip } from "@mui/material";
import { Copy } from "react-feather";

const ChatMessages = (props) => {
  const chatAreaRef = useRef(null);
  const history = useHistory();
  const [messages, setMessages] = useState([]);
  const [emailCopied, setEmailCopied] = useState(false);

  useEffect(() => {
    if (props.chatMessagesList && props.chatMessagesList.length) {
      let unreadCounter = 0;
      if (props.prospectTenantNames.length) {
        unreadCounter = props.prospectTenantNames[0].unread_no;
      }

      const prospectTenantMessages = props.chatMessagesList.filter(
        (message) => message.senderId === ""
      );
      const totalMessages = prospectTenantMessages.length;
      const filterUnreadMessages = props.chatMessagesList.map(
        (message, index) => {
          if (message.senderId === "") {
            // Check if this message is within the last 'unreadCounter' prospecttenant messages
            const isUnread =
              prospectTenantMessages.indexOf(message) >=
              totalMessages - unreadCounter;
            return { ...message, unreadMessage: isUnread ? 1 : 0 };
          }
          // If it's not a prospecttenant message (it's sent by you), set unreadMessage to 0
          return { ...message, unreadMessage: 0 };
        }
      );

      setMessages([...filterUnreadMessages]);
    }
  }, [props.chatMessagesList, props.unreadMessageList]);

  useEffect(() => {
    if (chatAreaRef.current) {
      setTimeout(() => {
        chatAreaRef.current.scrollTop = chatAreaRef.current.scrollHeight;
      });
    }
  }, [props.chatMessagesList]);

  const ShowTenantProspectName = (value) => {
    const findName = props.prospectTenantNames.find(
      (pt) => "+1" + pt.phone === value
    );
    if (findName) {
      return findName.first_name + " " + findName.last_name;
    } else {
      return value;
    }
  };

  const navigateTo = (value) => {
    const findId = props.prospectTenantNames.find(
      (pt) =>
        "+1" + pt.phone === value ||
        pt.first_name + " " + pt.last_name === value
    );
    if (findId) {
      if (findId.type === "Prospect") {
        history.push(`/people/prospects/details/${findId.prospect_id}`);
      } else {
        history.push(`/people/tenants/details/${findId.tenant_id}`);
      }
    }
  };

  return (
    <>
      {props.messageLoader && (
        <div className={`${styles.ChatBoxContentLoader}`}>
          <ContentLoader width={400} height={300}>
            <rect x="27" y="40" rx="3" ry="3" width="260" height="10"></rect>
            <rect x="27" y="60" rx="3" ry="3" width="240" height="10"></rect>
            <rect x="27" y="80" rx="3" ry="3" width="180" height="10"></rect>

            <rect x="127" y="140" rx="3" ry="3" width="240" height="10"></rect>
            <rect x="127" y="160" rx="3" ry="3" width="240" height="10"></rect>
            <rect x="127" y="180" rx="3" ry="3" width="120" height="10"></rect>

            <rect x="27" y="240" rx="3" ry="3" width="250" height="10"></rect>
            <rect x="27" y="260" rx="3" ry="3" width="230" height="10"></rect>
            <rect x="27" y="280" rx="3" ry="3" width="180" height="10"></rect>
          </ContentLoader>
        </div>
      )}

      <div
        ref={chatAreaRef}
        className={`${styles.ChatViewSec}`}
        style={{ overflowY: "scroll", maxHeight: "300px" }}
      >
        {messages.length > 0 &&
          messages.map((msg, i) => {
            return (
              <div 
                className={
                  msg.senderId
                    ? `${styles.MessageBlog} ${styles.Receiver}`
                    : `${styles.MessageBlog}`
                }
                key={i}
              >                
                  <div className={`${styles.MessageBlogInner}`}>
                    <div className={`${styles.MessageBlogCon}`}>
                      {msg.senderId && (
                        <p className={`${styles.MessageName}`}>
                          {msg.author}{" "}
                          <span className={`${styles.MessageTime}`}>
                            {moment(msg.createdAt).format("MMMM Do, h:mm A")}
                          </span>
                          <span className={`${styles.CopyText}`}><Copy /> {emailCopied ? "Copied" : "Copy"}</span>
                        </p>
                      )}
                      {!msg.senderId && (
                        <p
                          onClick={() => navigateTo(msg.author)}
                          className={`${styles.MessageName}`}
                        >
                          {ShowTenantProspectName(msg.author)}
                          <span className={`${styles.MessageTime}`}>
                            {moment(msg.createdAt).format("MMMM Do, h:mm A")}
                          </span>
                          <span className={`${styles.CopyText}`}><Copy /> {emailCopied ? "Copied" : "Copy"}</span>
                        </p>
                    )}
                    <CopyToClipboard text={msg.message} onCopy={() => {
                      setEmailCopied(true);
                      setTimeout(() => setEmailCopied(false), 2000);
                    }}>
                      <div className={`${styles.MessageDesMain}`}>
                        <p className={
                            msg?.unreadMessage
                              ? `${styles.MessageDes} ${styles.Unread}`
                              : `${styles.MessageDes}`
                          }
                        >
                          {msg.message}
                        </p>
                        {msg.media && msg.media.length > 0 && (
                          <div className={`${styles.MessageFileSec}`}>
                            <MessageFileViewer
                              media={msg.media}
                            ></MessageFileViewer>
                          </div>
                        )}
                      </div>
                    </CopyToClipboard>                                           
                    </div>
                  </div>
              </div>
            );
          })}

        {!props.messageLoader && messages.length === 0 && (
          <div className={`${styles.ChatBoxnoDataSec}`}>
            <img src="/static/img/chatIcon.png" alt="logo" />
            <p>Start a New Conversation</p>
          </div>
        )}
      </div>
    </>
  );
};

export default ChatMessages;
